// WhatsApp do Fábio (vendas) — mesmo número usado no ModalNewPlans.
const SALES_PHONE = '5541935005239'

const SALES_MESSAGE =
  'Olá, vi a mensagem sobre os planos novos e tenho uma dúvida.'

export const buildSalesWhatsappUrl = (): string =>
  `https://wa.me/${SALES_PHONE}?text=${encodeURIComponent(SALES_MESSAGE)}`
